import { useQuotaTest } from "@shared/features/settings/hooks";
import { getSubscriptionTypeDisplay } from "@shared/utils/misc";
import {
  LanguageNameSpaces,
  PlanUsageLimits,
  SubscriptionPlanType,
  UsageType,
} from "@shared/types";
import { useUserUsageTypes } from "@shared/utils/hooks/misc";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface useDowngradeQuotaModalProps {
  selectedPlanUsageLimits: PlanUsageLimits | undefined;
  currentQuotaUsage: PlanUsageLimits | undefined;
  planType?: SubscriptionPlanType;
}

const useDowngradeQuotaModal = ({
  selectedPlanUsageLimits,
  currentQuotaUsage,
  planType,
}: useDowngradeQuotaModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const { testQuota } = useQuotaTest();
  const usageTypes = useUserUsageTypes();

  const getOverLimitUsageTypes = () =>
    usageTypes.filter((usageType) => {
      return (
        usageType !== UsageType.BACKTESTING &&
        testQuota(
          usageType,
          currentQuotaUsage?.[usageType],
          selectedPlanUsageLimits?.[usageType]
        )
      );
    });

  const modalData = {
    title: t("downgrade_quota_modal.title"),
    content: [
      t("downgrade_quota_modal.above_limits", {
        plan: getSubscriptionTypeDisplay(planType),
      }),
      t("downgrade_quota_modal.adjust_usage"),
    ],
  };

  return {
    getOverLimitUsageTypes,
    modalData,
  };
};

export default useDowngradeQuotaModal;
